import Box from '@mui/material/Box';
import { forwardRef } from 'react';

import { svgColorClasses } from './classes';
import type { SvgColorProps } from './types';

interface Props extends SvgColorProps {
  bgcolor?: string;
}

// ----------------------------------------------------------------------
/**
 * alterei a prop para aceitar a cor de fundo, por conta dos icones que são brancos, (home minhacnh)
 */
export const SvgColor = forwardRef<HTMLSpanElement, Props>(
  (
    { src, width = 24, bgcolor = 'currentColor', className, sx, ...other },
    ref
  ) => (
    <Box
      ref={ref}
      component="span"
      className={svgColorClasses.root.concat(className ? ` ${className}` : '')}
      sx={{
        width,
        height: width,
        flexShrink: 0,
        display: 'inline-flex',
        bgcolor,
        mask: `url(${src}) no-repeat center / contain`,
        WebkitMask: `url(${src}) no-repeat center / contain`,
        ...sx,
      }}
      {...other}
    />
  )
);

SvgColor.displayName = 'SvgColor';
